import React, { useEffect, useState } from "react";
import './styles.css';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { splitQuotevariants, splitQuoteWrapperVariants } from "./variants";
import { wordVariants, wrapperVariants } from "../ProjMinorQuoteTile/variants";



const ProjSplitImages = ({srcs, quotes, size, aspectRatio, secondHollow=true}) => {
    const transformSecondLevel = 65;
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);
    const [isSecondLoaded, setIsSecondLoaded] = useState(false);
    const [useSrcs, setUseSrcs] = useState(null);

    const { ref:upperRef, inView:upperInView, entry: upperEntry } = useInView({
        /* Optional options */
        triggerOnce: true,
        threshold: 0,
    });

    const { ref: lowerInViewRef, inView: lowerInView, entry: lowerEntr } = useInView({
        triggerOnce: true,
        threshold: 0
    });

    const imgVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0
            }
        }, exit: {
            opacity: 0
        }
    }

    useEffect(()=> {
        let tmpRes = [];
        if(size){
            for(let i=0; i< srcs.length; i++){
                let tmp = srcs[i].backgroundImage;
                tmp = tmp.replace("mobile", size);
                tmpRes.push(tmp);
            }
        }
        setUseSrcs(tmpRes)
    }, [size])

    

    return(
        <>
            <div className="proj-split__wrapper">
                <div className={`split-row__wrapper proj-upper-split__wrapper ${!secondHollow ? 'hollow-text' : ''}`}>
                    <div
                        className="split-img__wrapper" 
                        style={{
                            flex: "0 0 45%",
                            aspectRatio: aspectRatio,
                            paddingRight: '5vw'
                        }}
                    >
                        <div style={{position: 'relative', height: '100%', width: '100%'}}>
                            { useSrcs &&
                                <>
                                    <img
                                        src={useSrcs[0].replace(size, 'placeholder')} 
                                    />
                                    <motion.img 
                                        initial="initial"
                                        animate={isFirstLoaded ? "animate" : "initial"}
                                        exit="exit"
                                        variants={imgVariants}
                                        src={useSrcs[0]} 
                                        onLoad={(e) => {
                                            setIsFirstLoaded(true);
                                        } }
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                        }}
                                    />
                                </>
                            }
                        </div>
                    </div>
                    <motion.div
                        className="split-quote__wrapper"
                        ref={upperRef}
                        style={{
                            transform: `translateY(-${transformSecondLevel/2}px)`
                        }}
                        initial="initial"
                        animate={upperInView ? "animate" : "initial"}
                        exit="exit"
                        variants={wrapperVariants}
                        custom={0} 
                    >
                        {quotes[0].split(" ").map((word, widx) => (
                            <div className="split-q-w__wrapper">
                            <motion.span 
                                className="split-quote-word"
                                variants={wordVariants}
                            >{word}&nbsp;</motion.span>
                            </div>
                        ))}
                    </motion.div>
                </div>
                <div 
                    className={`split-row__wrapper proj-lower-split__wrapper ${secondHollow ? 'hollow-text' : ''}`}
                    style={{
                        top: "0",
                        position: "relative"
                    }}
                >
                    <motion.div 
                        className="split-quote__wrapper"
                        ref={lowerInViewRef}
                        style={{
                            flex: "0 0 40%",
                            whiteSpace: "normal"
                        }}
                        initial="initial"
                        animate={lowerInView ? "animate" : "initial"}
                        exit="exit"
                        variants={wrapperVariants}
                        custom={0.2} 
                    >
                        {quotes[1].split(" ").map((word, widx) => (
                            <div className="split-q-w__wrapper">
                                <motion.span 
                                    className="split-quote-word"
                                    variants={wordVariants}
                                >{word}&nbsp;</motion.span>
                            </div>
                        ))}
                    </motion.div>
                    <div 
                        className="split-img__wrapper"
                        style={{
                            transform: `translateY(-${transformSecondLevel}px)`,
                            flex: "0 0 60%",
                            aspectRatio: aspectRatio,
                            paddingLeft: '5vw'
                        }}
                    >
                        <div style={{position: 'relative', height: '100%', width: '100%'}}>
                        { useSrcs &&
                            <>
                                <img 
                                    src={useSrcs[1].replace(size, "placeholder")} 
                                />
                                <motion.img 
                                    initial="initial"
                                    animate={isSecondLoaded ? "animate" : "initial"}
                                    exit="exit"
                                    variants={imgVariants}
                                    src={useSrcs[1]} 
                                    onLoad={(e) => {
                                        setIsSecondLoaded(true);
                                    } }
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                    }}
                                />
                            </>
                        }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProjSplitImages;